/* Tuesday morning vignette — a lived-in story to make the product concrete. */

import { Reveal } from "./Reveal";
import { GOLD } from "./constants";

export default function TuesdayMorningSection() {
  const moments = [
    { t: "9:00 AM", text: "You shot a maternity session Saturday. Eighty frames you actually love." },
    { t: "9:01 AM", text: "You upload them into Lumetier and drop the keepers into a folder called Selections.", em: true },
    { t: "9:03 AM", text: "You type 'Hello Sarah ✦' once and tap Send. Lumetier emails Sarah the gallery, your contract, and the deposit balance." },
    { t: "9:08 AM", text: "Sarah opens the gallery on her phone over coffee. It looks like your studio — not Pixieset's." },
    { t: "9:32 AM", text: "Sarah has favorited 24 photos. You haven't opened a spreadsheet. You haven't logged into a second tool.", em: true },
    { t: "Next Tuesday", text: "Sarah's balance auto-charges. Her edited gallery uploads. She gets a review request the day after. Two more bookings show up — referred by her." },
  ];

  return (
    <section id="interactive" className="relative py-32 overflow-hidden" data-testid="tuesday-section">
      <div className="absolute inset-0 pointer-events-none">
        <div
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[820px] h-[520px]"
          style={{ background: `radial-gradient(ellipse, ${GOLD}10 0%, transparent 65%)` }}
        />
      </div>
      <div className="relative max-w-3xl mx-auto px-6">
        <Reveal>
          <div className="text-center mb-16">
            <div className="text-[11px] uppercase tracking-[0.32em] text-stone-500 mb-5">A Tuesday morning</div>
            <h2
              className="text-4xl md:text-5xl font-light leading-tight text-stone-100"
              style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}
            >
              Here&apos;s what it{" "}
              <em className="italic" style={{ color: GOLD }}>actually</em> looks like.
            </h2>
            <p className="text-stone-400 mt-6 text-sm leading-relaxed max-w-md mx-auto">
              Not a feature list. A morning.
            </p>
          </div>
        </Reveal>

        <div className="space-y-5">
          {moments.map((m, i) => (
            <Reveal key={m.t} delay={i * 0.08}>
              <div className="flex gap-5 sm:gap-7 items-start">
                <div
                  className="shrink-0 w-20 sm:w-24 text-right text-[10px] uppercase tracking-[0.22em] pt-1 font-mono"
                  style={{ color: m.em ? GOLD : "rgba(168,162,158,0.65)" }}
                >
                  {m.t}
                </div>
                <div className="flex-1 border-l border-white/[0.12] pl-5 sm:pl-7 pb-1">
                  <p
                    className={`leading-relaxed ${m.em ? "text-stone-100 text-lg" : "text-stone-300 text-base"}`}
                    style={m.em ? { fontFamily: "'Cormorant Garamond', Georgia, serif", fontStyle: "italic" } : {}}
                  >
                    {m.text}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.5}>
          <div className="text-center mt-16 text-sm text-stone-500 max-w-md mx-auto leading-relaxed">
            That Tuesday is the product.
            <br />
            <span className="text-stone-400">Everything else is plumbing.</span>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
